export const enum UnknownEnum {
  unknown = 'unknown',
}